import useOnce from '../useOnce';

function useMount(handle) {
    useOnce(() => {
        handle();
    });
}

export default useMount;
